

























import Xbtn from "@/components/buttons/x-btn.vue";
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import VueQr from "vue-qrcode-component";
@Component({
  components: { VueQr, Xbtn },
  $_veeValidate: { validator: "new" },
})
export default class qr_code extends Vue {
  @Prop({
    default: () => {
      return document.URL;
    },
  })
  url_qr!: string;
  @PropSync("show", { default: false }) show_qr!: boolean;

  public get primary() {
    return "black"; //this.$vuetify.theme.currentTheme.primary;
  }
  onStartPrint() {
    this.downloadBase64File();
  }
  downloadBase64File() {
    var images = document.querySelectorAll("img");
    for (let i = 0; i < images.length; i++) {
      if (images[i].alt === "Scan me!") {
        const linkSource = images[i].src;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = "qr.png";
        downloadLink.click();
      }
    }
  }
}
